<template>
  <a-config-provider :locale="zh_CN">
    <div id="app">
      <!-- <router-view /> -->
	  <keep-alive>
		<router-view v-if="$route.meta.keepAlive"/>
	  </keep-alive>
	  <router-view v-if="!$route.meta.keepAlive"></router-view>
    </div>
  </a-config-provider>
</template>

<script>
import zh_CN from "ant-design-vue/lib/locale-provider/zh_CN";
import moment from "moment";
import "moment/locale/zh-cn";
moment.locale("zh-cn");
export default {
  name: 'App',
  data() {
    return {
      zh_CN,
    };
  },
  computed: {},
  created() {},
  methods: {},
};
</script>
<style lang="scss" scoped>
#app {
  width: 100%;
  height: 100vh;
  overflow: hidden;
  box-sizing: border-box;
}

</style>
<style> 
	.mainRightCont .ant-pagination-total-text{ float: left; font-size: 12px;} 
	.mainRightCont-Search .ant-list-pagination { text-align: center!important;} 
	.ant-empty{ display: flow!important; margin-top: 80px!important;}
	.ant-empty .ant-empty-image { height: auto!important;}
	.ant-empty .ant-empty-image img{ height: auto!important; width: 480px; max-width: 50%; margin: 0px auto;}
	.ant-empty .ant-empty-description{ font-size: 20px; font-weight:600;}
</style>